import React from 'react'
import { apiPut } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import { isEmpty, startCase } from 'lodash'
import useToastContext from 'hooks/useToastContext'
import { AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import helper from '../../utils/helpers'
import { BsArrowUpShort } from 'react-icons/bs'
import { NavLink } from 'react-router-dom'
import OImage from 'components/reusable/OImage'
import homeImage from '../../assets/images/home.png'
const CompanyTable = ({
  offers,
  getAllCompanies,
  user,
  paginationObj,
  sort,
  setSort,
  manager
}) => {
  const { t } = useTranslation()
  const notification = useToastContext()

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changeCompanyStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getAllCompanies()
      }
      // }
    } catch (error) {
      console.error('error in get all offer list==>>>>', error.message)
    }
  }

  return (
    <div className='p-3'>
      <div className='overflow-x-auto relative 
 border'>
        <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
          <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
            <tr>
              <th scope='col' className='py-3 px-6 text-center'>
                #
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sort_key === 'title' && sort.sort_type === 'asc') {
                    setSort({
                      sort_key: 'title',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'title',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex '>
                  <span>{t('COMPANY_NAME')} </span>
                  <span>
                    {sort.sort_key === 'title' && sort.sort_type === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sort_key === 'title' && sort.sort_type === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 text-left'>
                {t('COMPANY_LOGO')}
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'discount_type' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'discount_type',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'discount_type',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex items-center'>
                  <span>{t('O_EMAIL_ADDRESS')} </span>
                  <span>
                    {sort.sort_key === 'discount_type' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'discount_type' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'countryCode' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'countryCode',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'countryCode',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_COUNTRY_CODE')} </span>
                  <span>
                    {sort.sort_key === 'countryCode' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'countryCode' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'discount' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'discount',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'discount',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_MOBILE')} </span>
                  <span>
                    {sort.sort_key === 'discount' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'discount' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6'>
                {t('HEAD_OFFICE')}
              </th>

              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'validity' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'validity',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'validity',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('ORN')} </span>
                  <span>
                    {sort.sort_key === 'validity' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'validity' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 cursor-pointer'>
                <div className='flex justify-end'>
                  <span>{t('AGENT_NUMBER')} </span>
                </div>
              </th>
              <th scope='col' className='py-3 px-6 cursor-pointer'>
                <div className='flex justify-end'>
                  <span>{t('NO_OF_PROPERTY')} </span>
                </div>
              </th>
              <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (
                    sort.sort_key === 'createdAt' &&
                    sort.sort_type === 'asc'
                  ) {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'createdAt',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-end'>
                  <span>{t('O_CREATED_AT')} </span>
                  <span>
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                    {sort.sort_key === 'createdAt' &&
                      sort.sort_type === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                  </span>
                </div>
              </th>
              {(manager?.add || user?.role === 'admin') && (
                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_STATUS')}
                </th>
              )}
              <th scope='col' className='py-3 px-6 text-center'>
                {t('O_ACTION')}
              </th>
            </tr>
          </thead>
          <tbody>
            {offers &&
              offers?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.name} </td>

                  <td className='py-2 px-2 border-r text-center'>
                    <figure className='inline-block overflow-hidden rounded-full border-2 mb-0'>
                      <OImage
                        src={item?.logo ?? homeImage}
                        fallbackUrl={homeImage}
                        className='w-10 h-10'
                      />
                    </figure>
                  </td>
                  <td className='py-2 px-2 border-r text-left'>
                    {item?.email}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.countryCode}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.mobile}
                  </td>
                  <td className='py-2 px-2 border-r text-left'>
                    {startCase(item?.headOffice)}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>{item?.orn}</td>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.agentCount}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.propertyCount}
                  </td>
                  <td className='py-2 px-2 border-r text-right'>
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  {(manager?.add || user?.role === 'admin') && (
                    <td className='py-2 px-2 border-r text-center'>
                      <label
                        className='inline-flex relative items-center cursor-pointer'
                        title={`${
                          item?.status === 'active' ? 'Active' : 'Inactive'
                        }`}
                      >
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.status === 'active'}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? 'active' : 'inactive'
                              } ${item.name}?`,
                              item,
                              handelStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <li className='px-2 py-2 hover:bg-white hover:text-LightBlue'>
                          <NavLink
                            title={t('O_VIEW_USER')}
                            to='/company/view'
                            state={{ item }}
                          >
                            <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />{' '}
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(offers) && (
              <tr className='bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700'>
                <td className='py-2 px-2 border-r' colSpan={13}>
                  {t('O_NO_RECORD_FOUND')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CompanyTable
